import Authenticator from '@/services/authenticator'
import { login as mongoLogin } from '@/services/mongodb'
import { firebase } from '@/firebase'
import '@firebase/auth'

const auth = new Authenticator()

const state = {
  authenticated: false,
  accessToken: null,
  idToken: null,
  expiresAt: null,
  firebaseAuthenticated: true
}

const metaPrefix = 'https://xerpa-api.now.sh'

const getters = {
  accessToken() {
    return state.accessToken
  },
  idToken() {
    return state.idToken
  },
  consentGiven: (_state, getters) => {
    // const token = parseJwt(state.idToken)
    return getters.identity && getters.identity[`${metaPrefix}/consentGiven`]
  },
  authenticated(state) {
    return state.authenticated
  },
  // TODO remove and only user user.profile from userstore
  identity(state) {
    let profile = null
    if (state.idToken) {
      profile = parseJwt(state.idToken)
    }
    return profile
  }
}

const mutations = {
  authenticated(state, authData) {
    state.accessToken = authData.accessToken
    state.accessTokenExpiry = authData.expiresIn * 1000 + new Date().getTime()
    state.idToken = authData.idToken
    // TODO: change to authData.idTokenPayload.exp for expiry of the id token if at all needed
    state.expiresAt = authData.expiresIn * 1000 + new Date().getTime()
    state.authenticated = true
  },

  setFirebaseAuthenticated(state, authenticated) {
    state.firebaseAuthenticated = authenticated
  },

  logout(state) {
    state.authenticated = false
    state.accessToken = null
    state.idToken = false
    state.expiresAt = null
  }
}

const actions = {
  login() {
    auth.login()
  },
  // TODO: Add firebase logout as well
  logout({ commit }) {
    commit('logout')
    auth.logout({
      returnTo: `${window.location.origin}`
    })
  },

  async handleAuthentication({ commit, dispatch }) {
    try {
      const authResult = await auth.handleAuthentication()

      commit('authenticated', authResult)
      const profile = authResult.idTokenPayload
      const [, id] = profile.sub.split('|')
      const { email, nickname: username, picture } = profile
      commit('setProfile', { id, email, username, picture }, { root: true })

      const credentials = { id, authResult }

      await dispatch('firebaseLogin', credentials)

      await mongoLogin(credentials.authResult.idToken)

      return credentials
    } catch (err) {
      console.error(err)
      dispatch('showErrorSnackbar', err.message || 'Authentication error', {
        root: true
      })
    }
  },

  firebaseLogin({ commit }, credentials) {
    return (
      getFirebaseToken(credentials.authResult.accessToken, credentials.id)
        .then(token => {
          return firebase.auth().signInWithCustomToken(token)
        })
        // TODO: Setup token refresh
        // eslint-disable-next-line no-unused-vars
        .then(_res => {
          commit('setFirebaseAuthenticated', true)
          return credentials
        })
    )
  }
}

function getFirebaseToken(auth0Token, userId) {
  return fetch(
    `${process.env.VUE_APP_API_URL}/firebase/users/${userId}/token`,
    {
      headers: {
        Authorization: `Bearer ${auth0Token}`
      }
    }
  ).then(res => res.text())
}

function parseJwt(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

function parseToken(token) {
  let profile = null
  try {
    profile = JSON.parse(atob(token))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
  }
  return profile
}

export default {
  state,
  getters,
  mutations,
  actions
}
